import { installLogCapture } from './log-capture';

// Imported first in main.ts, for its effect: imports run before main.ts's own code, so this is how the recording starts
// before the rest of the app has loaded.
installLogCapture();
